import {IAirportInfo, ICommentInfo, INoteInfo} from '@/types/airport';
import {create} from 'zustand';

interface AirportNoteState {
  airportNoteUpdate: number;
  setAirportNoteUpdate: () => void;
  airportNoteBookmarkedUpdate: number;
  setAirportNoteBookmarkedUpdate: () => void;
  search: string;
  setSearch: (search: string) => void;
  airportNoteInfo: IAirportInfo | null;
  setAirportNoteInfo: (airportNoteInfo: IAirportInfo | null) => void;
  refreshAirportNote: number;
  setRefreshAirportNote: () => void;
  refreshComment: number;
  setRefreshComment: () => void;
  commentPanelVisible: ICommentInfo | null;
  setCommentPanelVisible: (commentPanelVisible: ICommentInfo | null) => void;
  airportNoteSector: string | null;
  setAirportNoteSector: (airportNoteSector: string | null) => void;
  selectedNote: INoteInfo | null;
  setSelectedNote: (selectedNote: INoteInfo | null) => void;
  noteSidePanelVisible: boolean;
  setNoteSidePanelVisible: (noteSidePanelVisible: boolean) => void;
  isEditNote: boolean;
  setIsEditNote: (isEditNote: boolean) => void;
  allComments: ICommentInfo[];
  setAllComments: (allComments: ICommentInfo[]) => void;
  allNotes: INoteInfo[];
  setAllNotes: (allNotes: INoteInfo[]) => void;
}

const useAirportNote = create<AirportNoteState>((set) => ({
  airportNoteUpdate: 0,
  setAirportNoteUpdate: () => set({airportNoteUpdate: Date.now()}),
  airportNoteBookmarkedUpdate: 0,
  setAirportNoteBookmarkedUpdate: () =>
    set({airportNoteBookmarkedUpdate: Date.now()}),
  search: '',
  setSearch: (search: string) => set({search}),
  airportNoteInfo: null,
  setAirportNoteInfo: (airportNoteInfo: IAirportInfo | null) =>
    set({airportNoteInfo}),
  refreshAirportNote: 0,
  setRefreshAirportNote: () => set({refreshAirportNote: Date.now()}),
  refreshComment: 0,
  setRefreshComment: () => set({refreshComment: Date.now()}),
  commentPanelVisible: null,
  setCommentPanelVisible: (commentPanelVisible: ICommentInfo | null) =>
    set({commentPanelVisible}),
  airportNoteSector: null,
  setAirportNoteSector: (airportNoteSector: string | null) =>
    set({airportNoteSector}),
  selectedNote: null,
  setSelectedNote: (selectedNote: INoteInfo | null) => set({selectedNote}),
  noteSidePanelVisible: false,
  setNoteSidePanelVisible: (noteSidePanelVisible: boolean) =>
    set({noteSidePanelVisible}),
  isEditNote: false,
  setIsEditNote: (isEditNote: boolean) => set({isEditNote}),
  allComments: [],
  setAllComments: (allComments: ICommentInfo[]) => set({allComments}),
  allNotes: [],
  setAllNotes: (allNotes: INoteInfo[]) => set({allNotes})
}));

export default useAirportNote;
